import { Paragraph } from "../../typography";
import { AssignedManagerItemStyles } from "./assignedManagerItem.styles";

const AssignedManagerItem = ({ fullName, email, contactNumber }) => {
  return (
    <AssignedManagerItemStyles>
      <Paragraph className="name">{fullName}</Paragraph>
      <Paragraph className="contact">{contactNumber || "—"}</Paragraph>
      <Paragraph className="email">{email}</Paragraph>
    </AssignedManagerItemStyles>
  );
};

export default AssignedManagerItem;
